export default __webpack_public_path__ + "static/media/virat_kohli_2.e29c91f5.jpg";